import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const features = [
  {
    title: "UAE Registered Business",
    desc:
      "GlobalGiftPass is a fully licensed company registered and operating out of the United Arab Emirates, fully compliant with local regulations.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M12 2L2 7v7c0 5.55 3.84 10.74 10 12 6.16-1.26 10-6.45 10-12V7z" />
      </svg>
    ),
  },
  {
    title: "Secure Card Payments",
    desc:
      "All transactions are processed through PCI-DSS compliant gateways with 3D Secure, SSL encryption and tokenized card handling — your data never sits with us.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4H4V6h16zm0 10H4v-6h16z" />
      </svg>
    ),
  },
  {
    title: "Anti-Fraud Systems",
    desc:
      "Every order passes through a multi-layered fraud detection engine — device fingerprinting, velocity checks, AVS, CVV, BIN matching and manual review on high-risk orders.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zM10 17l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z" />
      </svg>
    ),
  },
  {
    title: "Fast Digital Delivery",
    desc:
      "98% of orders are delivered instantly to your inbox. No shipping delays, no lost parcels — just the code, the moment payment is confirmed.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M13 2L3 14h7l-1 8 10-12h-7z" />
      </svg>
    ),
  },
  {
    title: "Dedicated Support Team",
    desc:
      "Reach us on WhatsApp or by email — every enquiry is logged and tracked until it's resolved.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2zm-2 12H6v-2h12zm0-3H6V9h12zm0-3H6V6h12z" />
      </svg>
    ),
  },
  {
    title: "Verified Suppliers",
    desc:
      "We source digital products exclusively through authorized distribution channels and brand-approved aggregators — every code is traceable, every code is genuine.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
    ),
  },
];

const stats = [
  { label: "Verified Brands", value: "500+" },
  { label: "Customer Rating", value: "4.9★" },
  { label: "Average Delivery", value: "30s" },
  { label: "Orders Delivered", value: "10K+" },
];

const WhyChooseUs = () => {
  return (
    <Fragment>
      <Navbar />

      <section className="gpwc-section">
        <div className="gpwc-bg-orb gpwc-bg-orb-tl" />
        <div className="gpwc-bg-orb gpwc-bg-orb-br" />

        <div className="gpwc-inner">
          <div className="gpwc-head">
            <div className="gpwc-eyebrow">
              <span className="gpwc-eyebrow-dot" />
              TRUST, BUILT-IN
            </div>
            <h1 className="gpwc-title">
              The reasons customers pick us — <span className="gpwc-title-accent">again and again</span>
            </h1>
            <p className="gpwc-sub">
              From licensing to delivery, every part of our operation is designed for one outcome:
              a safe, fast and reliable gifting experience.
            </p>
          </div>

          <div className="gpwc-stats">
            {stats.map((s, i) => (
              <div className="gpwc-stat" key={i}>
                <span className="gpwc-stat-val">{s.value}</span>
                <span className="gpwc-stat-label">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="gpwc-grid">
            {features.map((f, i) => (
              <article key={i} className="gpwc-card">
                <div className="gpwc-card-glow" aria-hidden="true" />
                <div className="gpwc-icon">{f.icon}</div>
                <h3 className="gpwc-card-title">{f.title}</h3>
                <p className="gpwc-card-desc">{f.desc}</p>
              </article>
            ))}
          </div>

          <div className="gpwc-cta">
            <div className="gpwc-cta-eyebrow">
              <span className="gpwc-eyebrow-dot" />
              READY TO START
            </div>
            <h3>Send the perfect gift in <span>seconds</span></h3>
            <p>Browse thousands of digital gift cards from authorized brands — delivered instantly to any inbox.</p>
            <div className="gpwc-cta-buttons">
              <Link to="/shop" className="gpwc-btn gpwc-btn-primary">
                Browse Gift Cards
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Link>
              <Link to="/contact" className="gpwc-btn gpwc-btn-ghost">
                Talk to Support
              </Link>
            </div>
          </div>
        </div>

        <style>{`
          .gpwc-section {
            position: relative;
            background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
            color: #e6e8ec;
            padding: 60px 22px 90px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            overflow: hidden;
          }
          .gpwc-bg-orb {
            position: absolute;
            width: 460px;
            height: 460px;
            border-radius: 50%;
            filter: blur(140px);
            opacity: 0.4;
            pointer-events: none;
          }
          .gpwc-bg-orb-tl { background: rgba(212,168,87,0.18); top: -180px; left: -120px; }
          .gpwc-bg-orb-br { background: rgba(212,168,87,0.12); bottom: -200px; right: -120px; }

          .gpwc-inner { position: relative; max-width: 1200px; margin: 0 auto; z-index: 1; }

          .gpwc-head { text-align: center; margin-bottom: 38px; }
          .gpwc-eyebrow {
            display: inline-flex; align-items: center; gap: 8px;
            padding: 6px 14px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px; font-weight: 700; letter-spacing: 2px;
            margin-bottom: 14px;
          }
          .gpwc-eyebrow-dot { width: 6px; height: 6px; border-radius: 50%; background: #d4a857; box-shadow: 0 0 10px #d4a857; animation: gpwc-pulse 1.6s ease-in-out infinite; }
          @keyframes gpwc-pulse { 0%,100% { opacity:1; transform: scale(1); } 50% { opacity:.55; transform: scale(.85); } }
          .gpwc-title {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 38px; font-weight: 700; color: #fff; margin: 0 0 12px; line-height: 1.2;
          }
          .gpwc-title-accent {
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text; background-clip: text; color: transparent;
            font-style: italic; font-weight: 600;
          }
          .gpwc-sub { font-size: 15px; color: #9aa0a8; max-width: 680px; margin: 0 auto; line-height: 1.65; }

          /* STATS */
          .gpwc-stats {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
            margin-bottom: 38px;
          }
          .gpwc-stat {
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.2);
            border-radius: 16px;
            padding: 22px;
            text-align: center;
            display: flex; flex-direction: column; gap: 6px;
            transition: border-color .25s ease, transform .2s ease;
          }
          .gpwc-stat:hover { border-color: rgba(212,168,87,0.45); transform: translateY(-2px); }
          .gpwc-stat-val {
            font-family: "Playfair Display", serif;
            font-size: 28px;
            font-weight: 700;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text; background-clip: text; color: transparent;
          }
          .gpwc-stat-label { font-size: 12px; color: #9aa0a8; text-transform: uppercase; letter-spacing: 1.4px; font-weight: 700; }

          /* GRID */
          .gpwc-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 18px;
            margin-bottom: 50px;
          }
          .gpwc-card {
            position: relative;
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.2);
            border-radius: 18px;
            padding: 28px 24px;
            overflow: hidden;
            transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;
          }
          .gpwc-card:hover {
            transform: translateY(-4px);
            border-color: rgba(212,168,87,0.55);
            box-shadow: 0 16px 36px rgba(212,168,87,0.14);
          }
          .gpwc-card-glow {
            position: absolute;
            top: -60px;
            right: -60px;
            width: 160px;
            height: 160px;
            background: radial-gradient(circle, rgba(212,168,87,0.18), transparent 70%);
            opacity: 0;
            transition: opacity .3s ease;
            pointer-events: none;
          }
          .gpwc-card:hover .gpwc-card-glow { opacity: 1; }
          .gpwc-icon {
            width: 50px; height: 50px;
            background: rgba(212,168,87,0.12);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 12px;
            display: flex; align-items: center; justify-content: center;
            margin-bottom: 16px;
          }
          .gpwc-card-title {
            font-family: "Playfair Display", serif;
            font-size: 19px; color: #fff; margin: 0 0 8px; font-weight: 700;
          }
          .gpwc-card-desc { font-size: 13.5px; color: #9aa0a8; line-height: 1.6; margin: 0; }

          /* CTA */
          .gpwc-cta {
            position: relative;
            background: linear-gradient(135deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.3);
            border-radius: 22px;
            padding: 50px 30px;
            text-align: center;
            overflow: hidden;
          }
          .gpwc-cta::before {
            content: "";
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            width: 500px; height: 500px;
            background: radial-gradient(circle, rgba(212,168,87,0.15), transparent 70%);
            pointer-events: none;
          }
          .gpwc-cta-eyebrow {
            position: relative;
            display: inline-flex; align-items: center; gap: 8px;
            padding: 6px 14px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px; font-weight: 700; letter-spacing: 2px;
            margin-bottom: 16px;
          }
          .gpwc-cta h3 {
            position: relative;
            font-family: "Playfair Display", serif;
            font-size: 30px; color: #fff; margin: 0 0 10px; font-weight: 700; line-height: 1.25;
          }
          .gpwc-cta h3 span {
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text; background-clip: text; color: transparent;
            font-style: italic; font-weight: 600;
          }
          .gpwc-cta p { position: relative; color: #9aa0a8; margin: 0 auto 24px; max-width: 540px; font-size: 14.5px; line-height: 1.6; }
          .gpwc-cta-buttons { position: relative; display: inline-flex; flex-wrap: wrap; gap: 12px; justify-content: center; }
          .gpwc-btn {
            display: inline-flex; align-items: center; gap: 10px;
            padding: 13px 26px;
            border-radius: 12px;
            font-weight: 800;
            text-decoration: none;
            font-size: 13px;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            transition: transform .2s ease, box-shadow .25s ease, gap .2s ease;
          }
          .gpwc-btn-primary {
            background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
            color: #0b0b0c;
          }
          .gpwc-btn-primary:hover {
            color: #0b0b0c; text-decoration: none;
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(212,168,87,0.35);
            gap: 12px;
          }
          .gpwc-btn-ghost {
            background: rgba(255,255,255,0.04);
            color: #d4a857;
            border: 1px solid rgba(212,168,87,0.3);
          }
          .gpwc-btn-ghost:hover {
            background: rgba(212,168,87,0.12);
            border-color: rgba(212,168,87,0.55);
            color: #f1cf85;
            text-decoration: none;
            transform: translateY(-2px);
          }

          @media (max-width: 991px) {
            .gpwc-stats { grid-template-columns: repeat(2, 1fr); }
            .gpwc-grid { grid-template-columns: repeat(2, 1fr); }
            .gpwc-title { font-size: 30px; }
            .gpwc-cta h3 { font-size: 26px; }
          }
          @media (max-width: 575px) {
            .gpwc-section { padding: 40px 14px 70px; }
            .gpwc-grid { grid-template-columns: 1fr; gap: 14px; }
            .gpwc-card { padding: 22px 18px; }
            .gpwc-cta { padding: 36px 20px; }
            .gpwc-title { font-size: 24px; }
            .gpwc-cta h3 { font-size: 22px; }
            .gpwc-stat-val { font-size: 22px; }
          }
        `}</style>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default WhyChooseUs;
